import { LabelSmall } from "baseui/typography"
import { FormattedMessage, useIntl } from "react-intl"
import { IControlledHeatingOutletRelease } from './types'
import { RELATION_TYPE } from "../../../../services/objects"
import { LogicRefrerence } from "../../../components/LogicReference/LogicReference"

export const SideviewPanel = (props: IControlledHeatingOutletRelease) => {
     
    const intl = useIntl();
    return (
        <>
        <LogicRefrerence automationApp={props} type={RELATION_TYPE.InputOutsideTemperature} enableAdd={true} text={intl.formatMessage({ id: 'Logics.InputOutsideTemperature', defaultMessage: "Reference for the outside temperature." })}></LogicRefrerence>
        <LogicRefrerence automationApp={props} type={RELATION_TYPE.InputSetpoint} enableAdd={true} text={intl.formatMessage({ id: 'Logics.InputSetpoint', defaultMessage: "Reference for the setpoint." })}></LogicRefrerence>
        <LogicRefrerence automationApp={props} type={RELATION_TYPE.InputEXTRequest} enableAdd={true} text={intl.formatMessage({ id: 'Logics.InputExtRequest', defaultMessage: "Reference for the external request." })}></LogicRefrerence>
        <LogicRefrerence automationApp={props} type={RELATION_TYPE.Output} enableAdd={false} text={intl.formatMessage({ id: 'Logics.OutputRelease', defaultMessage: "Reference for the release." })}></LogicRefrerence>
        </>
    )
}